import { CloseOutlined, PlusOutlined } from "@ant-design/icons"
import { Form, FormInstance, FormProps, Input, Modal, Select } from "antd"
import { ChangeEvent, useEffect, useRef, useState } from "react"
import './style.scss'
import { ICategoryCarEdit, editCategoryCar } from "../../../../../api/categoryCar/categoryCarApi"
import { URL_CAR_CATEGORY } from "../../../../../env"
import { useForm } from "antd/lib/form/Form"
import { ICarVersion } from "../../../../../api/carVersion/carVersionApi"
import { ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi"
import { getCLCarLines, getCLCategoryCar, getCLModelVehicle, getCLTypeVehicle } from "../../../../../api/selectOption/selectOptionsApi"
import { fommatSelectOption } from "../../../../../until"
interface ModalProps {
  isOpen: boolean
  infoCarVersion?: ICarVersion
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}
const ModalEditVersionCar: React.FC<ModalProps> = ({
  isOpen, infoCarVersion,
  onSubmitFormModal, closeModal
}) => {
  const imgRef = useRef<HTMLInputElement>(null);
  const inputRef = useRef<FormInstance>(null);
  const [form] = useForm();
  const isProgrammaticSet = useRef(false);
  const carLineId = Form.useWatch("carLineId", form);
  const idTypeVehicle = Form.useWatch("idTypeVehicle", form);
  const idCategoryCar = Form.useWatch("idCategoryCar", form);

  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])
  const [cLTypeVehicle, setCLTypeVehicle] = useState<ISelectOption[]>([])
  const [cLCategoryCar, setCLCategoryCar] = useState<ISelectOption[]>([])
  // const [cLTypeVehicle, setCLTypeVehicle] = useState<ISelectOption[]>([])

  //d xe
  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  //loại xe
  const gCLTypeVehicle = async () => {
    if (!carLineId) return
    const result = await getCLTypeVehicle(
      carLineId
    )
    if (result?.status) {
      setCLTypeVehicle(fommatSelectOption(result.data))
    }
  }

  // thương hiệu
  const gCLCategoryCar = async () => {
    if (!idTypeVehicle) return
    const result = await getCLCategoryCar(
      carLineId, idTypeVehicle
    )
    if (result?.status) {
      setCLCategoryCar(fommatSelectOption(result.data))
    }
  }

  //mẫu xe
  const gCLModelVehicle = async () => {
    if (!idCategoryCar) return
    const result = await getCLModelVehicle(
      carLineId, idTypeVehicle, idCategoryCar
    )
    if (result?.status) {
      setCLTypeVehicle(fommatSelectOption(result.data))
    }
  }

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    // const result = await editCategoryCar(Number(infoCategoryCar?.id), values.namebrand, values.codebrand, uploadedFile)
    // if (result?.status) {
    //   onSubmitFormModal?.(true, result?.message)
    // } else {
    //   onSubmitFormModal?.(false, result?.message)
    // }
  }

  useEffect(() => {
    if (isOpen) {

    } else {
      form.resetFields()
    }

  }, [isOpen])


  //  idCarlines  idTypeVehicle idCategoryCar idModelVehicle code  title
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa phiên bản xe</span>
          <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content ant-modal-size"
        closeIcon={false}
        footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
          <span className="text-sm text-98A2B3 cursor-pointer" onClick={closeModal}>Huỷ</span>
          <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
            onClick={submitForm}>
            Lưu
          </button>
        </div>}
      >
        <div className="px-6 py-2 d-flex flex-column gap-2">
          <div className="d-flex gap-2 flex-column pt-2">
            <div className="d-flex flex-column gap-4">

              <Form.Item
                label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="idCarlines"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn dòng xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="idTypeVehicle"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn loại xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Thương hiệu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="idCategoryCar"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn thương hiệu xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Mẫu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="idModelVehicle"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn thương hiệu xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Mã phiên bản xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}

                layout="vertical"
                name="code"
                rules={[{ required: true, message: 'Nhập mã phiên bản xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Mã phiên bản xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Tên phiên bản xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="title"
                rules={[{ required: true, message: 'Nhập tên phiên bản xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Tên phiên bản xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>



        </div>
      </Modal>
    </Form>

  )
}
export default ModalEditVersionCar
